/* SK Cookbook PDP — sticky mobile buy bar.
   Slides the bar in once the hero buy button scrolls out of view above the fold.
   Fade-in + real-cart quick-add are handled by sk-cookbooks.js (shared). */
(function () {
  "use strict";
  if (window.__skCookbookPdpInit) return;
  window.__skCookbookPdpInit = true;

  function init() {
    var anchor = document.querySelector("[data-sk-pdp-anchor]");
    var bar = document.querySelector("[data-sk-pdp-sticky]");
    if (!anchor || !bar) return;

    if (!("IntersectionObserver" in window)) return; // no JS sticky → page still works

    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle("is-shown", show);
      bar.setAttribute("aria-hidden", show ? "false" : "true");
    }, { threshold: 0 });

    io.observe(anchor);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
